import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, CadastraDocumentos } from './types';

export const INITIAL_STATE: CadastraDocumentos = {
	status: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): CadastraDocumentos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRA_DOCUMENTOS_REQUEST: {
				break;
			}

			case Types.CADASTRA_DOCUMENTOS_SUCCESS: {
				draft.status = 201;
				break;
			}

			case Types.CADASTRA_DOCUMENTOS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.LIMPA_CADASTRA_DOCUMENTOS: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}

		return draft;
	});
}
